export default {
  primaryColor: '#000000',
  secondaryColor: '#bdbdbd',
  accentColor: '#ff5700',

  backgroundPrimaryColor: '#f3f3f3',
  backgroundDefaultColor: '#ffffff',
};
